var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-about"},[_c('AboutChapter2'),_c('AboutChapter4'),_c('AboutChapter1'),_c('AboutChapter5'),_c('AboutChapter6'),_c('ScrollTopBtn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }